<template>
	<search-list :pageSizes="[25,30,40]" apiPath="/channel/list" :where="where" :searchKeys="searchKeys">
		<mm-lc title="Channel Status">
			<mm-adv-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Account Level">
			<mm-channel-accountlevel v-model="where.account_level" multiple />
		</mm-lc>
		<mm-lc title="Geo">
			<mm-offer-geos v-model="where.geo" multiple />
		</mm-lc>
		<mm-lc title="Account Manager">
			<mm-users v-model="where.account_manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Business Manager">
			<mm-users v-model="where.business_manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple :showMoreOptions="false" not_admin></mm-users>
		</mm-lc>
		<mm-lc title="Channel Type">
			<mm-channel-type v-model="where.channel_type" multiple />
		</mm-lc>
		<mm-lc title="IO Signed">
			<mm-tf-select v-model="where.sign_io" />
		</mm-lc>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="createChannel"></el-button>
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res"  >
            <el-table-column label="Id" prop="channel_id" />
			<el-table-column label="Channel name" prop="channel_name">
				<mm-get-detail slot-scope="sp" :row_id="sp.row.channel_id" :row_name="sp.row.channel_name" :row_type="'channel'"/>
			</el-table-column>
			<el-table-column label="Geo" prop="geo"/>
			<el-table-column label="Type" prop="channel_type" />
			<el-table-column label="Account Level" prop="account_level" :formatter="(row,column,v)=>`Level ${v.toUpperCase()}`" />
			<el-table-column label="Deduction Rate(%)" prop="defraud" :formatter="(row,column,v)=>`${(v*100).toFixed(0) + '%'}`" />
			<el-table-column label="Payout Rate(%)" prop="price_percent" :formatter="(row,column,v)=>`${(v*100).toFixed(0) + '%'}`" />
			<el-table-column label="Account Manager" prop="account_manager" />
			<el-table-column label="Business Manager" prop="business_manager" />
			<el-table-column label="status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="editRule(sp.row)">Edit Rule</el-dropdown-item>
							<el-dropdown-item @click.native="signIn(sp.row)">Sign In</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			channel_name: { label: "Channel Name", fuzzy: true },
			channel_id: { label: "Channel Id" },
			api_token: { label: "Token" },
		};
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			searchKeys,
			where: {
				channel_type: "",
				business_manager: "",
				account_manager: "",
				account_level: "",
				status: "",
				geo: "",
			},
			is_show_auth,
		};
	},
	methods: {
		createChannel() {
			window.open('/channelCreate');
		},
		edit(row){
			window.open('/channelEdit?id='+row.channel_id);
		},
		editRule(row){
			window.open('/channelRuleEdit?id='+row.channel_id);
		},
		getDetail(channel_id) {
			this.rootGetDetail(channel_id,true);
		},
		async signIn(row){
			const result = await this.$post('/channel/signIn',{channel_id:row.channel_id});
			window.open(result);
		}
	},
	inject: ['rootGetDetail'],

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
